<template>
    <div v-if="loading" class="m-5 text-center loading">
      <b-spinner></b-spinner>
    </div>
    <div v-else class="overview-container">
      <!-- Back Button -->
      <div v-if="selectedView" class="back-button-container">
        <button class="back-button" @click="handleBackClick">
          <i class="fas fa-arrow-left"></i> Back
        </button>
      </div>

      <div v-else-if="!selectedView" class="back-button-container">
        <router-link to="/parent/home" class="back-button">
          <i class="fas fa-arrow-left"></i> Back to Students List
        </router-link>
      </div>

      <div v-if="!selectedView" class="d-flex flex-row flex-wrap justify-content-center">
        <div class="d-flex flex-column btn btn-lg m-2 align-items-center justify-content-center report-btn" @click="selectedView = 'liveClass'">
          <img src="../../assets/images/live-class.svg" class="content-type-icon" alt="" />
          <label>Class Attendance</label>
        </div>
        <div class="d-flex flex-column btn btn-lg m-2 align-items-center justify-content-center report-btn" @click="selectedView = 'examResult'">
          <img src="../../assets/images/exam-icon.png" class="content-type-icon" alt="" />
          <label>Exam Results</label>
        </div>
        <div class="d-flex flex-column btn btn-lg m-2 align-items-center justify-content-center report-btn" @click="selectedView = 'assignmentResult'">
          <img src="../../assets/images/assignment.png" class="content-type-icon" alt="" />
          <label>Assignment Results</label>
        </div>

      </div>

      <!-- Content Display -->
      <div class="content-section" v-if="selectedView">
        <!-- Live Class Attendance -->
        <div v-if="selectedView === 'liveClass'">
          <live-class-attendance :student-id="studentId" :product-variant-id="productVariantId" />
        </div>

        <!-- Exam Result -->
        <div v-if="selectedView === 'examResult'">
          <exam-result :student-id="studentId" :product-variant-id="productVariantId" />
        </div>

        <!-- Assignment Result -->
        <div v-if="selectedView === 'assignmentResult'">
          <assignment-result :student-id="studentId" :product-variant-id="productVariantId" />
        </div>
      </div>
    </div>
  </template>

  <script>
  import { mapActions, mapState } from 'vuex';
  import LiveClassAttendance from '../../components/Parent/ContentOverview/LiveClassAttendance.vue';
  import ExamResult from '../../components/Parent/ContentOverview/ExamResult.vue';
  import AssignmentResult from '../../components/Parent/ContentOverview/AssignmentResult.vue';

  export default {
    name: 'ParentStudentOverview',
    components: {
      LiveClassAttendance,
      ExamResult,
      AssignmentResult,
    },
    data() {
      return {
        loading: false,
        selectedView: '', // Default is empty to show buttons only
        studentId: this.$route.params.studentId,
        productVariantId: this.$route.params.id,
      };
    },
    methods: {
      ...mapActions('user', ['getParentChildren']),
      handleBackClick() {
        this.selectedView = ''; // Reset to show buttons and hide component
      },
      async verifyParameters(studentId, productVariantId) {
        if(!studentId || !productVariantId) {
          return false;
        }

        const isChildAccountsDataAvailableInState = this.parentAccountChildUsers && this.parentAccountChildUsers.length > 0;

        if(!isChildAccountsDataAvailableInState) {
          try {
            this.loading = true;

            // this call will fetch data from API and save in state
            await this.getParentChildren();
          } catch (error) {
            console.error(error);
            this.loading = false;
            return false;
          } finally {
            this.loading = false;
          }
        }

        const studentUser = this.parentAccountChildUsers.find(u => u.id === studentId);

        console.log(studentUser, 'studentUser');

        if(!studentUser) {
          // when given studentId not found in current parent's child accounts
          return false;
        }

        const isProductVariantIdInSelectedUser = studentUser?.productVariants?.some(pv => pv.productVariantID === productVariantId);

        return isProductVariantIdInSelectedUser;
      }
    },
    computed: {
      ...mapState('user', ['parentAccountChildUsers']),
    },
    async created() {

      const studentId = this.$route.params.studentId;
      const productVariantId = this.$route.params.id;

      const isValidParametersPassed = await this.verifyParameters(studentId, productVariantId);

      if(!isValidParametersPassed) {
        await this.$router.push('/parent/home');
      }
    }
  };
  </script>
  
  <style scoped>
  .overview-container {
    padding: 1.5rem;
    max-width: 1200px;
    margin: 0 auto;
    min-height: 400px;
  }
  
  .breadcrumb {
    padding: 1rem 0rem 1rem 1rem;
    border-radius: 0.25rem;
    background: none !important;
  }
  
  .breadcrumb-item a {
    color: #007bff;
    text-decoration: none;
  }
  
  .breadcrumb-item a:hover {
    color: #0056b3;
    text-decoration: underline;
  }
  
  .breadcrumb-item.active {
    color: #6c757d;
  }
  
  .breadcrumb-item + .breadcrumb-item::before {
    content: var(--bs-breadcrumb-divider, ">") !important;
  }
  
  .btn {
    line-height: 2.5;
    padding: 0.375rem 1.5rem;
  }
  
  .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-bottom-left-radius: 0;
  }
  
  .btn-group > .btn {
    flex: none !important;
  }
  
  .btn-group {
    width: 100%;
    justify-content: start;
    display: flex;
    background-color: #f9f9f9;
    border-bottom: 1px solid #ddd;
    gap: 2rem;
    flex-direction: column;
    align-items: baseline;
  }
  
  .btn-outline-primary {
    border: 1px solid #dcdcdc !important;
    border-radius: 8px;
    color: #000000;
    max-width: none !important;
    border: none !important;
    background-color: #f9f9f9;
  }

  .iconbutton {
    width: 100%;
    display: flex;
    align-items: center;
    padding-right: 2rem;
    justify-content: space-between;
  }
  
  .iconbutton:hover {
    color: #000000;
    background-color: #ddd !important;
    box-shadow: none !important;
    border-radius: 0;
    cursor: pointer;
  }
  
  .btn.active {
    box-shadow: none !important;
  }
  
  .btn-outline-primary.active {
    background-color: #fff !important;
    color: #000000;
    border-bottom: 2.5px solid red !important;
    border-radius: 0;
  }
  
  .btn-outline-primary.active:focus {
    box-shadow: none !important;
  }
  
  .content-section {
    overflow: visible;
    padding-top: 0;
  }
  
  .content-type-icon {
    height: 2rem;
    margin-right: 0.75rem;
  }

.back-button-container{
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.back-button {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: var(--primary-color);
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
  text-decoration: none;
}

.back-button i {
  margin-right: 0.5rem;
}
.arrow-icon{
  color: var(--primary-color);
}

.loading{
  color: var(--primary-color);
}

.report-btn {
  background-color: #ededed;
  width: 300px;
  height: 150px;
}

.report-btn:hover {
  transform: scale(1.05);
  cursor: pointer;
  background-color: #ddd;
}

.report-btn > img {
  width: auto;
  height: 4rem;
}
  
  @media (min-width: 768px) {
    /* .btn-group {
      flex-direction: row;
    } */
  
    .btn-outline-primary {
      flex: 1;
      max-width: 250px;
    }
  }
  
  @media (max-width: 767px) {
    .btn-group {
      flex-direction: column;
    }
  
    .btn-outline-primary {
      width: 100%;
      margin-bottom: 0.5rem;
    }
  }
  </style>